import { SAVED_SEARCH_URL_PARAM } from '@aibees/elephant/context/search-params-url-sync';
import { ParsedPreset, SearchBrowseParams } from '@aibees/shared/definition';
import { ElephantPresetType } from '@aibees/elephant/types';
import { useFindSearchItemPath } from './use-find-search-item-path';

/**
 * Builds the "view" link for a saved-search preset shown in the View Records card.
 * Filters are no longer kept in the URL, so the link points at the search route
 * with a short `?saved-search=<presetId>` that `useApplySavedSearch` resolves on
 * load (instead of a long `?<filters>` query string that could hit HTTP 414).
 */
export function useSavedSearchCardViewPath(
  item: ParsedPreset<SearchBrowseParams>
) {
  const searchItemPath = useFindSearchItemPath(
    (item?.type || 'COMPANY') as ElephantPresetType
  );
  const canView = !!item?.id;
  const path = canView
    ? `${searchItemPath}?${SAVED_SEARCH_URL_PARAM}=${item.id}`
    : '';

  return { path, canView };
}
